import {RestArgument} from './rest-argument';
export class SortConfiguration {

  fields: Array<string>;
  reversed: boolean | null | undefined = null;

  //Callback for when the sort direction has changed somehow.
  //This callback is set by the PdsSortFields directive and it's
  //purpose is to keep the DOM manipulation code in the directive
  //(where it belongs) but to be triggered from the SortTask instance.
  //(not in a directive)
  sortChangedCallback: () => void;

  /**
   * Setting the sortDirection is setting the default sort for the grid widget. (if it's ascending or descending)
   * Only one sort configuration should be set as the default sort.
   *
   * @param fields
   * @param additionalFields: This allows you to not use an array if you don't want to.
   * new SortConfiguration('first-name', 'last-name') is the same as new SortConfiguration(['first-name', 'last-name'])
   * @param sortDirection
   */
  constructor(fields: Array<string> | string, ...additionalFields: Array<string>) {

    if (fields instanceof Array) {
      this.fields = <Array<string>>fields;
    } else {
      this.fields = [<string>fields];
    }

    if (additionalFields != null) {
      this.fields = this.fields.concat(additionalFields);
    }
  }

  setSortDirection(sortDirection: SortDirection | null | undefined): void {
    switch (sortDirection) {
      case SortDirection.ascending:
        this.reversed = false;
        break;
      case SortDirection.descending:
        this.reversed = true;
        break;
      default:
        this.reversed = null;
        break;
    }
  }

  /**
   * Inteneded to be used by PdsSortFields to give a callback to manipulate
   * the DOM after the sort direction has changed.
   */
  setSortChangedCallback(callback: () => void): void {
    this.sortChangedCallback = callback;
  }

  getRestArguments(): Array<RestArgument> {
    let restArgs: Array<RestArgument> = [];
    this.fields.forEach((fieldId: string) => {
      if (fieldId.startsWith('++')) {
        restArgs.push(new RestArgument(fieldId.substring(2), '=', 'asc'));
      } else if (fieldId.startsWith('--')) {
        restArgs.push(new RestArgument(fieldId.substring(2), '=', 'desc'));
      } else if (fieldId.startsWith('+')) {
        restArgs.push(new RestArgument(fieldId.substring(1), '=', this.reversed ? 'desc' : 'asc'));
      } else if (fieldId.startsWith('-')) {
        restArgs.push(new RestArgument(fieldId.substring(1), '=', this.reversed ? 'asc' : 'desc'));
      } else {
        restArgs.push(new RestArgument(fieldId, '=', this.reversed ? 'desc' : 'asc'));
      }
    });
    return restArgs;
  }

  getPersistenceObject(): Object | undefined {
    let value: { fields: Array<string>, reversed?: boolean} = {
      fields: this.fields
    };

    if (this.reversed != null) {
      value.reversed = this.reversed;
    }

    return value;
  }

  restoreFromPersistenceObject(value: Object): void {
    let state = <{ fields: Array<string>, reversed?: boolean}>value;
    this.fields = state.fields;

    if (state.reversed != null) {
      this.reversed = state.reversed;
    }
  }
}

export enum SortDirection {
  ascending,
  descending,
  notSorted
}
